import { type ClassValue, clsx } from "clsx"
import { parse } from "date-fns"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Parse a date-only string (YYYY-MM-DD) as local midnight.
 * Unlike `new Date("2025-05-06")` which parses as UTC midnight,
 * this returns midnight in the user's local timezone.
 */
export function parseLocalDate(dateStr: string): Date {
  return parse(dateStr, "yyyy-MM-dd", new Date())
}
